import Resource from '@/api/resources/Resource'

class SampleTagService extends Resource {
    async findAllActiveForLaboratory(laboratoryId) {
        return this.axios.get(`/laboratories/${laboratoryId}/sampletags`)
            .then(response => response.data)
    }

    async updateTagsOfSample(laboratoryId, caseId, sampleId, sampleTagIds) {
        const data = {
            entityIdentifiers: sampleTagIds
        }
        const response = await this.axios.put(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/tags`, data)
        return response.data
    }
}

export default new SampleTagService()
